import {profileSkillsPropTypes} from "../profile-skills/profile-skills";
import {Person, Profile, Skill} from "@betrue/shared/interfaces";
import {ProfileSkillsFromView, SkillOption} from "./profile-skills-form.view";
import {useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
import {JobCategories} from "../job-categories/job-categories";
import {
  currentPerson,
  currentProfile,
  useAutocomplete,
  usePerson,
  usePersonView,
  useProfile,
  useViewV2
} from "@betrue/front/services";
import {CircularProgress} from "@material-ui/core";


const profileSkillsFromPropTypes = {
  skillsLinkedToYourJobTitle: PropTypes.string,
  selectYourJobLabel: PropTypes.string,
  ...profileSkillsPropTypes
}

export type ProfileSkillsFromProps = InferProps<typeof profileSkillsFromPropTypes>

export const ProfileSkillsFrom = (props: ProfileSkillsFromProps) => {
  const [{autocomplete}, result] = useAutocomplete()

  const [, viewProfile] = usePersonView()
  const [, {addSkillToProfile}] = useProfile<Profile>(currentProfile)
  const [jobSkills, setJobSkills] = useState<Skill[]>([])
  const [filteredSkills, setFilteredSkills] = useState<Skill[]>([])

  useEffect(() => {
    if (viewProfile) {
      setJobSkills((viewProfile?.job?.baseSkills ? viewProfile.job?.baseSkills : []
        ).filter((it) => !viewProfile.skills.map((ps) => ps.skill.label).includes(it.label))
      )
      refreshFilteredSkills()
    }
  }, [viewProfile])

  useEffect(() => {
    refreshFilteredSkills()
  }, [result])

  const refreshFilteredSkills = () => {
    if (viewProfile && result) {
      setFilteredSkills(result.filter(
        (it) => (viewProfile.skills.map((ps) => ps.skill).filter((sk) => sk.label === it.label)).length == 0))
    }
  }

  const handleAddSkill = (skill: Skill): void => {
    if (skill) {
      //  setJobSkills(jobSkills.filter((it) => skill.id !== it.id))
      if (viewProfile.skills.map((it) => it.skill).filter((sk) => skill.label === sk.label)) {
        addSkillToProfile({...skill}, viewProfile.id)
      }
    }
  }

  const handleAutoCompleteInputChange = (value: string) => {
    autocomplete(value)
  }

  const handlerAutoCompleteOnChange = (newValue) => {
    if (typeof newValue === 'string') {
      handleAddSkill({
        version: 0,
        removed: false,
        label: newValue,
        key: newValue,
        id: null,
        usageCount: 0
      })
    } else if (newValue && newValue.inputValue) {
      handleAddSkill({
        label: newValue.key,
        removed: false,
        version: 0,
        key: newValue.key,
        id: null,
        usageCount: 0
      })
    } else {
      handleAddSkill(!newValue?.id && newValue?.key ? {
        label: newValue?.key,
        key: newValue.key,
        id: null,
        usageCount: 0
      } : newValue)
    }
  }

  if (!viewProfile) return (<><CircularProgress/></>)
  return (
    <span>
      {viewProfile.job ? (<ProfileSkillsFromView
        autoCompleteOnChange={handlerAutoCompleteOnChange}
        experiencesHeader={props.experiencesHeader}
        skillsHeader={props.skillsHeader}
        skillsLinkedToYourJobTitle={props.skillsLinkedToYourJobTitle}
        autoCompleteOptions={filteredSkills as SkillOption[]}
        autoCompleteOnInputChange={handleAutoCompleteInputChange}
        experiencesHeaderHelper={props.experiencesHeaderHelper}
        skillsHeaderHelper={props.skillsHeaderHelper}
        baseSkills={jobSkills as SkillOption[]}
        addSkill={handleAddSkill}
        canDelete={true} // TODO add read and write access
        canUpdate={true}/>) : (<><h1>{props.selectYourJobLabel}</h1><JobCategories/></>)}

    </span>)


};

ProfileSkillsFrom.WEB_COMPONENT_NAME = 'bt-profile-skills-from'

ProfileSkillsFrom.propTypes = profileSkillsFromPropTypes
